import { createContext, useContext, useState, useCallback, type ReactNode } from "react"

type Lang = "fr" | "en"

interface LanguageContextType {
  lang: Lang
  toggleLang: () => void
  t: (fr: string, en: string) => string
}

const LanguageContext = createContext<LanguageContextType | null>(null)

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>("fr")

  const toggleLang = useCallback(() => {
    setLang(prev => (prev === "fr" ? "en" : "fr"))
  }, [])

  const t = useCallback(
    (fr: string, en: string) => (lang === "fr" ? fr : en),
    [lang]
  )

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLang() {
  const context = useContext(LanguageContext)
  if (!context) throw new Error("useLang must be used within LanguageProvider")
  return context
}
